// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.changebarcode', {
        url:'/changebarcode',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/changebarcode/changebarcode.tpl.html',
            controller: 'SupportCaseChangeBarcodeController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseChangeBarcodeController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = false;
    vm.selectedProduct = {};
    vm.selectedProductVariant = {};
    vm.selectedProductCopy = {};
    vm.selectedProductVariantCopy = {};
    vm.newBarcode = '';

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.isAllowedToSave = isAllowedToSave;
    vm.startEditing = startEditing;
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;

    activate();

    function activate() {
    }

    function startEditing() {
        vm.isEditing = true;
    }
    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmUpdateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                SupportApiService.changeBarcode({ productVariantId: vm.selectedProductVariant.id, barcode: vm.newBarcode }).then(function(response) {
                    cancelEditing();
                    ToasterService.showSuccess($translate.instant('support.barcodeChanged'), $translate.instant('support.supportCase'));
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function cancelEditing() {
        vm.isEditing = false;
        removeProduct();
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
        loadSpinnerService.start("mainSpinner");
        SupportApiService.getProduct(vm.selectedProduct.id).then(function(response) {
            vm.selectedProduct = response;
            vm.selectedProductCopy = angular.copy(response);
            vm.selectedProductVariant = {};
            vm.selectedProductVariantCopy = {};
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
    function removeProduct() {
        //vm.selectedProduct = {};
        vm.selectedProductVariant = {};
        //vm.selectedProductCopy = {};
        vm.selectedProductVariantCopy = {};
        vm.newBarcode = '';
        $scope.$broadcast('clearArticleEvent');
    }

    function isAllowedToSave() {
        return vm.selectedProduct && vm.selectedProduct.id > 0 &&
            vm.selectedProductVariant && vm.selectedProductVariant.id > 0;
    }
}

angular
    .module('supportcases.changebarcode', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseChangeBarcodeController', SupportCaseChangeBarcodeController);
